module.exports = __webpack_public_path__ + "img/g3.e81da617.jpg";